<template>
  <div id="app" c_name="MobileApp">
    <TopMobile />
    <router-view/>
    <BottomMobile />
    <WxQQWebGo v-show="isWxQQ"/>
  </div>
</template>

<script>
// @ is an alias to /src
import TopMobile from '@/components/TopMobile.vue'
import BottomMobile from '@/components/BottomMobile.vue'
import WxQQWebGo from '@/components/WxQQWebGo.vue'
import tools from './tools/tools'

// <meta name="App-Config" content="fullscreen=yes,useHistoryState=yes,transition=yes">
export default {
  name: 'MobileHome',
  components: {
    BottomMobile,
    TopMobile,
    WxQQWebGo
  },
  mounted () {
    // 发送app安装参数消息
    tools.sendInstallParam()
    // 初始化 openinstall
    tools.initOpenInstall(this.$store.state.configs.openInstall)
  },
  computed: {
    isWxQQ () {
      const isTrue = tools.isWXQQ()
      return isTrue
    }
  }
}
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
article, aside, body, dd, details, dl, dt, figcaption, figure, footer, form, h1, h2, h3, h4, h5, h6, header, hgroup, html, label, li, menu, nav, ol, p, section, table, td, th, ul {
    margin: 0;
    padding: 0;
}
li, ol, ul {
    list-style: none outside none;
}
.page_space {
  margin-top: 1rem;
}

.page_top {
  margin-top: 4rem;
}
.page_bg {
  background: rgb(246,247,251);
}
.page_text_protocol {
  padding: 1rem;
  text-align: left;
}
.ql-align-center {
 text-align: center;
}
.page_text_protocol h3 {
  font-size: 1rem;
  font-weight: bold;
  text-align: center;
}
.page_text_protocol dd {
  margin-left: 0;
}
.page_text_protocol dd p{
  text-indent: 2em;
}

.ml_05 {
  margin-left: 0.5rem;
}
.ml_1 {
  margin-left: 1rem;
}
</style>
